<template lang="html">
  <div></div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import PayoutFormGroup from '@/components/forms/payout/PayoutFormGroup.vue';
import ErrorMessageBlock from '@/components/forms/payout/ErrorMessageBlock.vue';
import PayoutFormPreloader from '@/components/forms/other/PayoutFormPreloader.vue';
import PayoutFormControlButton from '@/components/forms/other/PayoutFormControlButton.vue';
import {VerificationModel} from '@/models/verification/payout';
import type {PayoutDocumentType} from '@/models/verification/payout';
import {ModelEvents} from 'capitalist-shared/src/core/model';
import debounce from "@/polyfill/Debounce";

@Component({
  components: {
    'payout-form-group': PayoutFormGroup,
    'error-message': ErrorMessageBlock,
    'pre-loader': PayoutFormPreloader,
    'ctrl-button': PayoutFormControlButton,
  },
  name: 'abstract-payout-verification-form',
})
export default class AbstractPayoutVerification extends Vue {
  @Prop({default: 'ru'})
  language!: string

  @Prop({default: null})
  document?: PayoutDocumentType

  @Prop({default: null})
  dataForSign?: string

  @Prop({default: ''})
  username!: string

  @Prop({default: '/webapi/finance/payout'})
  url!: string

  @Prop({default: null})
  btnNextLabel: string | null | undefined

  @Prop({default: null})
  btnBackLabel: string | null | undefined

  @Prop({default: 'payment'})
  documentType!: string

  model = new VerificationModel()

  submitting = false

  getUsername() {
    return this.model.profile?.username || this.username;
  }

  mounted() {
    this.load();
  }

  get isLoading() {
    return this.model.loadingStatus.isLoading;
  }

  updateUrl() {
    this.model.setUrl(this.url);
  }

  load() {
    this.updateUrl();
    this.$emit(ModelEvents.modelLoadingStart);
    this.model
      .setDocument(this.document)
      .setDocumentType(this.documentType)
      .load(this.document!.verificationType).then((result: any) => {
      this.$emit(ModelEvents.modelLoaded, this.model);
    }, () => {
      this.$emit(ModelEvents.modelLoadingFail, this.model);
    });
  }

  goBack() {
    this.$emit('go-back');
  }

  submit() {
    if (this.submitting) return;
    this.submitting = true;
    try {
      window.document.activeElement ? (window.document.activeElement as any).blur() : null;
    } catch (e) {
    }

    this.updateUrl();
    this.$emit(ModelEvents.modelSubmitStart);
    this.model
      .setDocument(this.document)
      .submit()
      .then((result: any) => {
        this.$emit(ModelEvents.documentVerified, this.document);
        this.submitting = false;
      }).catch((err) => {
      this.submitting = false;
      this.$emit(ModelEvents.modelInvalidated);
      throw err;
    });
  }

  debouncedSubmit = debounce(this.submit, 300);
}
</script>

<style scoped lang="less">

</style>
